import { connect } from 'react-redux';
import { StoreState } from '../../reducers';
import Utils from '../../utils/index';
import { Api } from '../../typings/api';
import Home from '../../components/Home';

const getWelcomePageId = (template: Api.Template): number | undefined => {
	const welcomePageUrl = template && template.welcomepage && template.welcomepage.url;

	if (!welcomePageUrl) {
		return undefined;
	}
	return Utils.getMediaId(welcomePageUrl);
};


const mapStateToProps = ({ galleryInfos: { template } }: StoreState, ownProps) => ({
	welcomePageId: getWelcomePageId(template)
});

export default connect(mapStateToProps)(Home);



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/containers/Home/index.tsx